<script>
import Vue from 'vue'
import DetailNewOrder from './popup/detailNewOrder'
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import OrderCard from '@/components/order-card'
import store from '@/state/store'
import Loader from '@/components/widgets/loader'
import BellRing from '@/components/bell-ring'
import { connectSocket } from '../../../state/socket.js';
import { apiService } from '@/helpers/api.service';
import { firstArrMinute } from '../../../utils/utilsDate.js'
import { permissionsMap, checkPermission } from '@/utils/utilsPermissions';

export default {
    components: { Layout, PageHeader, OrderCard, DetailNewOrder, Loader, BellRing},
    props: {
    },
    data() {
        return {
            loading: true,
            orders: [],
            newOrders: [],
            inPreparationOrders: [],
            readyOrders: [],
            orderSelected: null,
            columnSelected: null,
            isPageVisible: false,
            ordersInPreparation: [],
            socket: null,
            ordersDelivery: [],
            isShowModal: store.getters["isShowModal"],
            onChange: store.getters["orders/getChangeWelly"],
            newOrderInterval: null,
            canceledOrderNumber: null,
            showNotification: false,
            firstArrMinute: firstArrMinute
        };
    },
    watch: {
        newOrders() {
            if (!this.isPageVisible && this.newOrders.length > 0) {
              document.title = `(+${(this.newOrders.length)}) -  Welly Go`;
            }
        }
    },

    mounted() {

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && (!this.socket || this.socket.disconnected)) {
                this.getWebSocket()
            }
        });
       
       
        document.addEventListener("visibilitychange", this.handleVisibilityChange);

        this.$nextTick(() => {
            const modal = document.querySelector('#isShowModal');
            if (modal) {
            const modalBody = modal.querySelector('.modal-body');
            if (modalBody) {
                modalBody.style.padding = '0';
            }
            }
        });
        this.checkNotificationPermission()
        this.getOrders()
        this.canUpdateStoreOpen()
        this.getWebSocket()
        this.newOrderInterval = setInterval(() => {
            this.isNewOrder()
        }, 5000);
        this.setupAutoRefresh();
        if (!this.isIOS()) {
            Vue.notification.requestPermission()
        }
        this.canUpdateStoreOpen()
    },
    unmounted() {
        clearInterval(this.newOrderInterval)
    },
    methods: {
        canUpdateStoreOpen() {
            return checkPermission(permissionsMap.UPDATE_STORE_OPEN, this.$store.state.permissions);
        },
        closeModal() {
            return this.$store.commit('setIsShowModal', false);
        },
        checkNotificationPermission() {
            if(this.isIOS() || this.isSafari()) {
                return;
            } else {
                if (Notification.permission === "denied" || Notification.permission === "default") {
                    return this.$store.commit('setIsShowModal', true);
                }
            }
        },
        isSafari() {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        },
        isIOS() {
            return /iPhone|iPad|iPod/i.test(navigator.userAgent);
        },
        handleVisibilityChange() {
            if (document.hidden) {
                this.isPageVisible = false;
            } else {
                this.isPageVisible = true;
                document.title = "Welly Go";
            }
        },
        showNotificationWeb(order) {
            const dishDetails = order?.dishes
                .map(dish => `${dish?.quantity ?? 1}x ${dish?.name ?? ''}`)
                .join('; ');

            // Crear notificación estándar
            const notification = new Notification("Welly GO", {
                body: `Pedido #${order?.code ?? ''} - ${dishDetails}`,
            });

            notification.addEventListener('action', (event) => {
                if (event.action === "view-order") {
                    window.open('https://resto.wellygo.app', '_blank');
                }
            });

            // Reproducir sonido manualmente (funciona en Windows y macOS)
            // Esto se ejecuta independientemente de la notificación del sistema
            this.playCustomSound();
        },

        playCustomSound() {
            // Crear un elemento de audio temporal si no existe referencia a bellRing
            if (!this.$refs.bellRing) {
                const audioElement = new Audio('/music/bell_ring.mp3');
                audioElement.play().catch(error => {
                    console.error('Error al reproducir sonido:', error);
                });
            } else {
                // Usar el componente bellRing existente si está disponible
                this.$refs.bellRing.playSound();
            }
        },

        async getWebSocket() {
            if (this.isReconnecting) return;

            try {
                this.isReconnecting = true;
                this.socket = await connectSocket();

                this.socket.on("connect", () => {
                    console.log('🔌 Socket conectado');
                });

                this.socket.on("disconnect", () => {
                    console.warn('❌ Socket desconectado. Reintentando en 7 segundos...');
                    if (!this.isReconnecting) {
                        this.isReconnecting = true;
                        setTimeout(() => {
                            this.getWebSocket();
                        }, 7000);
                    }
                });


            this.socket.on("newOrder", (res) => {
                let newOrder = res
                const checkOrderNew = this.newOrders.findIndex(x => x._id === newOrder._id);
                const checkOrderPrep = this.inPreparationOrders.findIndex(x => x._id === newOrder._id);
                const checkOrderReady = this.readyOrders.findIndex(x => x._id === newOrder._id);
                if (checkOrderNew === -1 && checkOrderPrep === -1 && checkOrderReady === -1) {
                    this.$store.commit('addNewOrder', newOrder);
                    newOrder.isNew = true
                    this.newOrders.push(newOrder)
                    this.showNotificationWeb(newOrder);
                }
            });

            this.socket.on("riderAssigned", (res) => {
                let changeIndex = this.newOrders.map(item => item._id).indexOf(res._id);
                if (changeIndex != -1) {
                    if (!this.timers[res._id]) {
                    this.startTimerForOrder(res._id);
                }
                this.newOrders[changeIndex].rider = res.rider;
                } else {
                    changeIndex = this.inPreparationOrders.map(item => item._id).indexOf(res._id);
                    if (changeIndex != -1) {
                        this.inPreparationOrders[changeIndex].rider = res.rider
                    } else {
                        changeIndex = this.readyOrders.map(item => item._id).indexOf(res._id);
                        this.readyOrders[changeIndex].rider = res.rider
                    }
                }
            });

            this.socket.on("userCanceled", (res) => {
                let removeIndex = this.newOrders.map(item => item._id).indexOf(res._id);
                if (removeIndex != -1) {
                    this.newOrders.splice(removeIndex, 1);
                } else {
                    removeIndex = this.inPreparationOrders.map(item => item._id).indexOf(res._id);
                    if (removeIndex != -1) {
                        this.inPreparationOrders.splice(removeIndex, 1);
                    } else {
                        removeIndex = this.readyOrders.map(item => item._id).indexOf(res._id);
                        this.readyOrders.splice(removeIndex, 1);
                    }
                }
                this.canceledOrderNumber = res.code;
                this.stopPlayingSound();
                
                if (this.newOrders.length === 0) {
                    document.title = "Welly Go";
                }
            });

        } catch (error) {
            if (!this.isReconnecting) {
                this.isReconnecting = true;
                setTimeout(() => {
                    this.getWebSocket();
                }, 7000);
            }
        }
        },
        getOrders() {
            apiService.getOrders()
                .then(res => {
                    this.orders = res
                    this.filterOrders(this.orders)
                    this.isNewOrder()
                    this.loading = false
                })
        },
        filterOrders(orders) {
            this.newOrders = []
            this.inPreparationOrders = []
            this.readyOrders = []
            if (orders && orders.length > 0) {
                for (const order of orders) {
                    const status = order.status.code
                    switch (status) {
                        case "new":
                            this.newOrders.push(order)
                            break;
                        case "preparing":
                            this.inPreparationOrders.push(order)
                            break;
                        case "prepared":
                            this.readyOrders.push(order)
                            break;
                        default:
                            return
                    }
                }
            }

        },
        openDetailNewOrder(order, column) {
            this.orderSelected = order;
            this.columnSelected = column;
            this.$bvModal.show('infoOrder');
        },
        updateStatus(status, id, time) {
            let index
            let order
            switch (status) {
                case "preparing":
                    index = this.newOrders.map(item => item._id).indexOf(id);
                    order = this.newOrders[index]
                    order.prepTime = time
                    order.status = {}
                    order.status.createdAt = new Date()
                    this.inPreparationOrders.push(order)
                    this.newOrders.splice(index, 1);
                    break;
                case "prepared":
                    index = this.inPreparationOrders.map(item => item._id).indexOf(id);
                    order = this.inPreparationOrders[index]
                    this.readyOrders.push(order)
                    this.inPreparationOrders.splice(index, 1);
                    break;
                case "picked":
                    index = this.readyOrders.map(item => item._id).indexOf(id);
                    this.readyOrders.splice(index, 1);
                    break;
                case "rejected":
                    index = this.newOrders.map(item => item._id).indexOf(id);
                    if (index != -1) {
                        this.newOrders.splice(index, 1);
                    } else {
                        index = this.inPreparationOrders.map(item => item._id).indexOf(id);
                        if (index != -1) {
                            this.inPreparationOrders.splice(index, 1);
                        } else {
                            index = this.readyOrders.map(item => item._id).indexOf(id);
                            this.readyOrders.splice(index, 1);
                        }
                    }
                    break;
                default:
                    return
            }
        },
        isNewOrder() {
            const now = new Date()
            this.newOrders.map((order) => {
                let createdAt
                if (order.status) {
                    createdAt = new Date(order.status.createdAt)
                } else {
                    createdAt = new Date(order.createdAt)
                }
                const timeDifference = now - createdAt
                if (timeDifference <= 120000) {
                    return order.isNew = true
                }
                return order.isNew = false
            });
        },
        setupAutoRefresh() {
            setTimeout(() => {
                this.getOrders()
            }, 300000);
        },
        showCancelNotification(orderNumber) {
            this.canceledOrderNumber = orderNumber;
            this.showNotification = true;
            setTimeout(() => {
                this.showNotification = false;
            }, 5000);
        },
        stopPlayingSound() {
            if (this.$refs.bellRing) {
                this.$refs.bellRing.stopPlayingSound();
            }
        }
    }
}
</script>

<template>
    <Layout>
        <PageHeader />
        <Loader v-show="loading"></Loader>
        <BellRing ref="bellRing" />
        <b-modal id="isShowModal" :visible="isShowModal" @close="closeModal" class="custom-modal" centered size="lg" hide-footer="true" no-close-on-backdrop no-close-on-esc>
            <div class="modal-container">
                <div class="modal-content">
                    <div class="modal-left">
                    <img src="@/assets/images/logoModal.svg" alt="Notification Icon" class="notification-image" />
                    </div>
                    <div class="modal-right">
                    <h2 class="modal-title">¡No te pierdas ningún pedido!<br />Activa las notificaciones</h2>
                    <p class="modal-instructions">
                        Sigue estos pasos en cualquier navegador para recibir alertas en tiempo real y gestionar tus pedidos al instante.
                    </p>
                    <ol class="instruction-list">
                        <li>Haz clic en el <strong>ícono de permisos</strong> (generalmente en el extremo izquierdo de la barra de direcciones).</li>
                        <li>Selecciona <strong>"Permitir notificaciones"</strong>.</li>
                        <li>¡Listo! Ahora recibirás avisos de nuevos pedidos.</li>
                    </ol>
                    </div>
                </div>
                <div class="footer-note">
                    <p>
                    <span class="footer-icon">📍</span> Verifica que las <strong>notificaciones estén habilitadas</strong> en la configuración de tu sistema operativo:
                    </p>
                    <ul>
                    <li><strong> ● En Windows:</strong> Ve a "Configuración" > "Sistema" > "Notificaciones" y asegúrate de que las notificaciones para tu navegador estén activadas.</li>
                    <li><strong> ● En macOS:</strong> Ve a "Preferencias del Sistema" > "Notificaciones" y permite las notificaciones para tu navegador.</li>
                    </ul>
                </div>
                </div>
        </b-modal>


        <div v-show="!loading">
            <div class="row resto-margin" :style="{ 'margin-top': !canUpdateStoreOpen() ? '3rem' : '0' }">
                <div class="col-md-4">
                    <section class="body-card-welly">
                        <header class="resto-cards-header resto-nuevos-pedidos">
                            <h2>Nuevos pedidos</h2>
                            <span> {{ newOrders.length }} </span>
                        </header>
                        <div class="cards-container-welly">
                            <div class="card-welly" v-for="(order, index) in newOrders" :key="index">
                                <OrderCard :order="order" :column="'new'"
                                    @view-detail="openDetailNewOrder(order, 'news')" />
                            </div>
                        </div>
                    </section>
                </div>

                <div class="col-md-4">
                    <section class="body-card-welly">
                        <header class="resto-cards-header resto-preparacion ">
                            <h2>Pedidos en preparación</h2>
                            <span> {{ inPreparationOrders.length }} </span>
                        </header>
                        <div class="cards-container-welly">
                            <div class="card-welly" v-for="(order, index) in inPreparationOrders" :key="index">
                                <OrderCard :order="order" :column="'preparing'"
                                    @view-detail="openDetailNewOrder(order, 'preparing')" />
                            </div>
                        </div>
                    </section>
                    <div v-if="showNotification">
                        <p class="text-center notification-canceled">El pedido {{ canceledOrderNumber }} fue cancelado</p>
                    </div>
                </div>

                <div class="col-md-4">
                    <section class="body-card-welly">
                        <header class="resto-cards-header resto-listos">
                            <h2>Pedidos listos</h2>
                            <span> {{ readyOrders.length }} </span>
                        </header>
                        <div class="cards-container-welly">
                            <div class="card-welly" v-for="(order, index) in readyOrders" :key="index">
                                <OrderCard :order="order" :column="'done'"
                                    @view-detail="openDetailNewOrder(order, 'done')" />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>



        <DetailNewOrder :order="orderSelected" :column="columnSelected" :popoverShow="false" :detailTotal="false"
            :timeOptions="firstArrMinute" :time="15" :timeToggle="true"
            @update-status="(status, id, time) => updateStatus(status, id, time)" />
    </Layout>
</template>

